import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  FRAUD_ALERT_PARTY_IDENTITY_GS_QUERY,
  ALERT_PARTY_IDENTITY_GS_QUERY,
  FRAUD_ALERT_ASSOC_CUSTOMERS_GS_QUERY,
  ALERT_ASSOC_CUSTOMERS_GS_QUERY
} from './constant';
import AlertDetailPartyIdentity from '../../common/AlertDetailPartyIdentity';
import AlertAssocCustomers from '../../common/AlertAssocCustomers';
import { TM_FRAUD_SOURCE_STRINGS } from '../../../util/GlobalConstant';
import SimilarKYCCustomer from '../smartAssessment/GeneralInfoTabCardViews/similarKYCCustomer';
import { connect } from 'react-redux';
import {
  getCommonKYCcustomers,
  getCommonKYCcustomersDownload
} from '../../../redux/actions/common';
import AssociatedAccounts from '../../common/associatedAccounts/AssociatedAccounts';

const CustomerDetailsTab = ({
  settings,
  alertId,
  sourceId,
  getCommonKYCcustomersData,
  commonKYCCustomers,
  commonKYCCustomersDownload,
  getCommonKYCcustomersDownloadData
}) => {
  const [customerID, setCustomerID] = useState(null); // Initialize with null or default value

  const getCustomerID = (ID) => {
    setCustomerID(ID);
  };

  return (
    <>
      <AlertDetailPartyIdentity
        settings={settings}
        alertId={alertId}
        gsQuery={
          sourceId === TM_FRAUD_SOURCE_STRINGS.FRAUDIAD
            ? FRAUD_ALERT_PARTY_IDENTITY_GS_QUERY
            : ALERT_PARTY_IDENTITY_GS_QUERY
        }
        getCustomerID={getCustomerID}
      />
      <AlertAssocCustomers
        settings={settings}
        alertId={alertId}
        gsQuery={
          sourceId === TM_FRAUD_SOURCE_STRINGS.FRAUDIAD
            ? FRAUD_ALERT_ASSOC_CUSTOMERS_GS_QUERY
            : ALERT_ASSOC_CUSTOMERS_GS_QUERY
        }
      />
      <AssociatedAccounts
        customerId={customerID}
        settings={settings}
        collapsible
      />
      <SimilarKYCCustomer
        getCommonKYCcustomersData={getCommonKYCcustomersData}
        getCommonKYCcustomersDownloadData={getCommonKYCcustomersDownloadData}
        commonKYCCustomers={commonKYCCustomers}
        commonKYCCustomersDownload={commonKYCCustomersDownload}
        alertId={alertId}
        customerId={customerID}
        collapseMode={true}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  const { commonKYCCustomers = {}, commonKYCCustomersDownload = {} } =
    state.amlsCommon;
  return { commonKYCCustomers, commonKYCCustomersDownload };
};

const mapDispatchToProps = (dispatch) => ({
  getCommonKYCcustomersData: (payload) =>
    dispatch(getCommonKYCcustomers(payload)),
  getCommonKYCcustomersDownloadData: (payload) =>
    dispatch(getCommonKYCcustomersDownload(payload))
});

CustomerDetailsTab.propTypes = {
  settings: PropTypes.object,
  alertId: PropTypes.string.isRequired,
  sourceId: PropTypes.string.isRequired // Add PropTypes validation for sourceId
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerDetailsTab);
